/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CommercialEmailConsentStateEnum = {
    granted: 'granted',
    noDecision: 'no_decision',
    refused: 'refused'
};
/**
 * Check if a given object implements the CommercialEmailConsent interface.
 */
export function instanceOfCommercialEmailConsent(_value) {
    return true;
}
export function CommercialEmailConsentFromJSON(json) {
    return CommercialEmailConsentFromJSONTyped(json, false);
}
export function CommercialEmailConsentFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clauseVersion': json['clauseVersion'] == null ? undefined : json['clauseVersion'],
        'consented': json['consented'] == null ? undefined : json['consented'],
        'consentedAt': json['consentedAt'] == null ? undefined : (new Date(json['consentedAt'])),
        'state': json['state'] == null ? undefined : json['state'],
        'withdrawnAt': json['withdrawnAt'] == null ? undefined : (new Date(json['withdrawnAt'])),
    };
}
export function CommercialEmailConsentToJSON(json) {
    return CommercialEmailConsentToJSONTyped(json, false);
}
export function CommercialEmailConsentToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'clauseVersion': value['clauseVersion'],
        'consented': value['consented'],
        'consentedAt': value['consentedAt'] == null ? value['consentedAt'] : value['consentedAt'].toISOString(),
        'state': value['state'],
        'withdrawnAt': value['withdrawnAt'] == null ? value['withdrawnAt'] : value['withdrawnAt'].toISOString(),
    };
}
